import { render, staticRenderFns } from "./AgentOverview.vue?vue&type=template&id=2f84a324&"
import script from "./AgentOverview.vue?vue&type=script&lang=js&"
export * from "./AgentOverview.vue?vue&type=script&lang=js&"
import style0 from "./AgentOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports